import { css } from '@emotion/react';

/**
 * Utility to combine Tailwind classes with Chakra styles
 */
export const hybridStyles = {
  // Background effects
  glassmorphism: (bg = 'white/10') => css({
    backdropFilter: 'blur(12px)',
    background: bg,
  }),
  
  // Hover effects
  cardHover: css({
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    },
  }),
  
  // Button effects
  buttonScale: css({
    transition: 'all 0.15s ease-in-out',
    '&:hover': {
      transform: 'scale(1.02)',
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  }),
  
  // Gradient backgrounds
  primaryGradient: css({
    bg: 'linear-gradient(135deg, #0a57c2 0%, #0a7dc2 100%)',
  }),
  
  // Text gradients
  textGradient: css({
    background: 'linear-gradient(135deg, #0a57c2 0%, #0a7dc2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  }),
};

/**
 * Convert Tailwind-like spacing to Chakra props
 */
export const spacing = {
  section: { py: 16, px: 4 },
  container: { maxW: '7xl', mx: 'auto' },
  card: { p: 8 },
  header: { p: 4 },
};

/**
 * Custom theme extensions that work with both systems
 */
export const themeExtensions = {
  colors: {
    primary: '#0a57c2',
    'background-light': '#f5f7f8',
    'background-dark': '#101822',
  },
  fonts: {
    display: 'Manrope, sans-serif',
  },
};